import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function LastCallBetweenOffset({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getLastCallBetween(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setLastCallBetween(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Latest call"
      description="Filter by how long since the latest call was made (either answered or unanswered)"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '2 hours or less',
    value: {
      From: hours(-2),
    },
  },
  {
    label: '2+ hours',
    value: {
      To: hours(-2),
    },
  },
  {
    label: '12+ hours',
    value: {
      To: hours(-12),
    },
  },
  {
    label: '24+ hours',
    value: {
      To: hours(-24),
    },
  },
];

function hours(hours: number) {
  return hours * 60;
}

function setLastCallBetween(
  offset: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryLastCallAtOffset: offset,
  });
}

function getLastCallBetween(query: ace_index.FindInput) {
  return query.SummaryLastCallAtOffset;
}

type Value = ace_index.FindInput['SummaryLastCallAtOffset'];
